export enum DetailsLinkTypeEnum {
  OUTDATED = 'OUTDATED',
  RELOCATION = 'RELOCATION',
  MOVEOUT = 'MOVEOUT',
  MOVEOUT_IGNORE_ERROR = 'MOVEOUT_IGNORE_ERROR',
}
